export default __webpack_public_path__ + "static/media/main_5.1215da37.jpg";